import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"

import { Box, TextField, Typography } from "@mui/material"
export default function NumerationTab({ localProject, setLocalProject }) {
  return (
    <Box>
      <TextField
        label={i18n.t("editProject.number")}
        value={localProject.identifierNumber || ""}
        onChange={e =>
          setLocalProject(lp => ({
            ...lp,
            identifierNumber: e.target.value,
          }))
        }
        fullWidth
        variant="outlined"
        size="small"
        margin="normal"
      />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {i18n.t("editProject.dynamicNumerationInfo") + " "}
        <a href="/generalProfile" style={{ color: "#1976d2" }}>
          {i18n.t("editProject.companyManagement")}
        </a>
        .
      </Typography>
    </Box>
  )
}

NumerationTab.propTypes = {
  localProject: PropTypes.object.isRequired,
  setLocalProject: PropTypes.func.isRequired,
}
